import { render, staticRenderFns } from "./PayRunApproval.vue?vue&type=template&id=49a55525&scoped=true"
import script from "./PayRunApproval.vue?vue&type=script&lang=js"
export * from "./PayRunApproval.vue?vue&type=script&lang=js"
import style0 from "./PayRunApproval.vue?vue&type=style&index=0&id=49a55525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a55525",
  null
  
)

export default component.exports